import * as Yup from "yup";

/**
 * Validation class for Service Category form
 * Contains validation schema for the service category master fields
 */
class ServiceCategoryValidationClass {
  /**
   * Service Category validation schema
   * @param {function} t - Translation function
   * @returns {Yup.ObjectSchema} Validation schema for the service category form
   */
  static serviceCategoryValidation(t = (key) => key) {
    return Yup.object().shape({
      name: Yup.string()
        .trim()
        .required(t("admin.service_category_validation_name_required"))
        .max(100, t("admin.service_category_validation_name_max_length")),
    });
  }
}

export default ServiceCategoryValidationClass;
